'use strict'

const LIMIT_MESSAGE = 30;

const TYPE_CHAT_ASSIGNED = 0;
const TYPE_CHAT_NOT_ASSIGNED = 1;
const TYPE_CHAT_OTHER_ASSIGNED = 2;
const TYPE_CHAT_ARCHIVED = 4;

const TYPE_MESSAGE_SENT = 1
const TYPE_MESSAGE_RECEIVED = 2;
const TYPE_MESSAGE_AUTOMATIC = 3;
const TYPE_MESSAGE_AUTOMATIC_CONTATTO = 4;

const TYPE_ATTACH_IMAGE = "image";
const TYPE_ATTACH_OTHER = "other";
const TYPE_ATTACH_AUDIO = "audio";

const ARGOMENTO_FRONT = 1;
const ARGOMENTO_AMMINISTRAZIONE = 2;
const ARGOMENTO_SUPPORTO = 3;
const ARGOMENTO_ENERGIA = 4;

exports.TYPE_CHAT_ASSIGNED = TYPE_CHAT_ASSIGNED;
exports.TYPE_CHAT_NOT_ASSIGNED = TYPE_CHAT_NOT_ASSIGNED;
exports.TYPE_CHAT_OTHER_ASSIGNED = TYPE_CHAT_OTHER_ASSIGNED;
exports.TYPE_CHAT_ARCHIVED = TYPE_CHAT_ARCHIVED;
exports.LIMIT_MESSAGE = LIMIT_MESSAGE;
exports.TYPE_MESSAGE_SENT = TYPE_MESSAGE_SENT;
exports.TYPE_MESSAGE_RECEIVED = TYPE_MESSAGE_RECEIVED;
exports.TYPE_MESSAGE_AUTOMATIC = TYPE_MESSAGE_AUTOMATIC;
exports.TYPE_MESSAGE_AUTOMATIC_CONTATTO = TYPE_MESSAGE_AUTOMATIC_CONTATTO;
exports.TYPE_ATTACH_IMAGE = TYPE_ATTACH_IMAGE;
exports.TYPE_ATTACH_OTHER = TYPE_ATTACH_OTHER;
exports.TYPE_ATTACH_AUDIO = TYPE_ATTACH_AUDIO

exports.ARGOMENTO_FRONT = ARGOMENTO_FRONT
exports.ARGOMENTO_AMMINISTRAZIONE = ARGOMENTO_AMMINISTRAZIONE
exports.ARGOMENTO_SUPPORTO = ARGOMENTO_SUPPORTO
exports.ARGOMENTO_ENERGIA = ARGOMENTO_ENERGIA
